import { render, staticRenderFns } from "./CalendarDetailsModal.vue?vue&type=template&id=45a86370&scoped=true"
import script from "./CalendarDetailsModal.vue?vue&type=script&lang=js"
export * from "./CalendarDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a86370",
  null
  
)

export default component.exports